import React from 'react';
import { Box, Card, Divider } from '@mui/material';
import ChevronRightTwoToneIcon from '@mui/icons-material/ChevronRightTwoTone';
import { ButtonWrapper } from './ButtonWrapper';
import { useHistory } from 'react-router-dom';

export const FulfillmentPlanBlock = () => {
  const history = useHistory();

  const handleButtonClick = async (): Promise<void> => {
    history.push('fulfillment-plans');
  };

  return (
    <Card>
      <Box display='flex' alignItems='center' p={2}></Box>
      <Divider />
      <ButtonWrapper fullWidth endIcon={<ChevronRightTwoToneIcon />} onClick={handleButtonClick}>
        {'Fulfillment Plans'}
      </ButtonWrapper>
    </Card>
  );
};
